import { Box, Text } from '@chakra-ui/react';

type DesktopAuthHeaderType = {
  title: string;
  subTitle?: string;
  titleAlign?: 'left' | 'center';
};

const DesktopAuthHeader: React.FC<DesktopAuthHeaderType> = ({
  title,
  subTitle,
  titleAlign = 'left',
}: DesktopAuthHeaderType) => {
  return (
    <Box
      display="flex"
      flexDir="column"
      alignItems={titleAlign === 'center' ? 'center' : 'stretch'}
      justifyContent="center"
      mt={0}
      px={0}
      w="100%"
    >
      <Text
        fontSize={{ base: '3xl', md: '4xl' }}
        fontWeight="700"
        fontFamily="Inter"
        w="100%"
        textAlign={titleAlign}
        color="body"
      >
        {title}
      </Text>
      {subTitle && (
        <Text
          fontSize="md"
          w="100%"
          fontFamily="Satoshi"
          mt={3}
          textAlign={titleAlign}
          color="secondary2"
        >
          {subTitle}
        </Text>
      )}
    </Box>
  );
};

export default DesktopAuthHeader;
